import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, BookOpenIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const items = [{
  icon: <BookOpenIcon className="w-6 h-6 text-[#E69D4F]" data-id="element-244" />,
  name: 'The Backyard Pitmaster',
  desc: 'The 30-day "Heat-Flow" Blueprint — Complete Digital Guide',
  value: '$29'
}, {
  icon: <span className="text-2xl" data-id="element-245">🎁</span>,
  name: 'Brisket Rescue 911',
  desc: 'Full Emergency Guide (PDF)',
  value: 'FREE'
}];
export function ValueStack() {
  const {
    formatted,
    isUrgent
  } = useCountdown(14, 8);
  return <section id="pricing" className="py-16 md:py-20 px-4 bg-dark" data-id="element-246">
      <div className="max-w-4xl mx-auto" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-248">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-ivory mb-2 uppercase tracking-tight" data-id="element-249">
            Get Your Copy of
          </h2>
          <h2 className="font-heading text-5xl md:text-6xl font-black text-[#E69D4F] uppercase tracking-tight" data-id="element-250">
            The Backyard Pitmaster
          </h2>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-full rounded-2xl overflow-hidden mb-10" data-id="element-251">
          <img src="https://cdn.magicpatterns.com/uploads/4ErqEDMZ7VNVqmiYGkkFpp/The_Backyard_Pitmaster.png" alt="The Backyard Pitmaster - Texas-Quality BBQ on a Budget" className="w-full h-auto object-cover" data-id="element-252" />
        </motion.div>

        {/* Value Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl overflow-hidden border border-[#3A2A1A] mb-10 bg-[#1C1410]" data-id="element-253">
          {/* Orange gradient header */}
          <div className="bg-gradient-to-r from-[#E69D4F] to-[#C45F2A] px-4 py-3 md:px-8 md:py-5 border-b-4 border-[#964215]" data-id="element-254">
            <h3 className="font-heading text-xl md:text-3xl font-black text-[#0F1111] uppercase tracking-tight" data-id="element-255">
              What You Get Today
            </h3>
          </div>

          {/* Item */}
          <div className="flex flex-col" data-id="element-256">
            {items.map((item, index) => <div key={index} className="px-6 sm:px-8 py-6 flex items-center gap-5" data-id="element-257">
                <div className="shrink-0 text-[#E69D4F] opacity-70" data-id="element-258">
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0" data-id="element-259">
                  <h4 className="text-ivory font-bold text-lg leading-tight" data-id="element-260">
                    {item.name}
                  </h4>
                  <p className="text-[#8A7A6A] text-sm mt-1" data-id="element-261">{item.desc}</p>
                </div>
                <div className="text-[#E69D4F] font-heading font-bold text-xl sm:text-2xl shrink-0" data-id="element-262">
                  {item.value}
                </div>
              </div>)}
          </div>

          {/* Total Value Footer */}
          <div className="border-t-2 border-[#3A2A1A] px-6 sm:px-8 py-6 flex justify-between items-end bg-[#161010]" data-id="element-263">
            <div data-id="element-264">
              <p className="text-[#8A7A6A] text-sm font-heading uppercase tracking-widest mb-1" data-id="element-265">
                Regular Price
              </p>
              <p className="text-[#E69D4F] font-heading font-black text-3xl sm:text-4xl md:text-5xl line-through decoration-[#8A7A6A]/50" data-id="element-266">
                $29
              </p>
            </div>
            <div className="text-right" data-id="element-267">
              <p className="text-[#8A7A6A] text-sm font-heading uppercase tracking-widest mb-1" data-id="element-268">
                Today Only
              </p>
              <p className="text-[#E69D4F] font-heading font-black text-4xl sm:text-5xl md:text-6xl" data-id="element-269">
                $6.99
              </p>
            </div>
          </div>
        </motion.div>

        {/* Price Box */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-dark-elevated to-dark border-2 border-[#E69D4F]/60 rounded-2xl md:rounded-3xl p-6 sm:p-10 md:p-16 text-center relative shadow-[0_0_60px_rgba(230,157,79,0.12)]" data-id="element-270">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-[#F2B851] to-[#C45F2A] text-[#0F1111] px-8 py-2 rounded-full font-black text-sm tracking-widest uppercase" data-id="element-271">
            Best Value
          </div>

          <p className="font-heading text-ivory text-2xl sm:text-3xl md:text-4xl font-bold mb-2 uppercase tracking-tight" data-id="element-272">
            Today Only:
          </p>

          <div className="flex justify-center items-baseline gap-1 mb-4" data-id="element-273">
            <span className="text-[#E69D4F] text-3xl sm:text-5xl font-black" data-id="element-274">
              $
            </span>
            <span className="text-[#E69D4F] text-6xl sm:text-8xl md:text-9xl font-black leading-none tracking-tighter" data-id="element-275">
              6.99
            </span>
          </div>

          <p className="text-green-500 font-bold text-lg sm:text-2xl mb-4" data-id="element-276">
            You save $22.01 (76% OFF)
          </p>

          {/* Timer Box */}
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-dark border border-[#E69D4F]/40 rounded-lg px-4 sm:px-6 py-2 sm:py-3 mb-6 sm:mb-10" data-id="element-277">
            <span className="text-smoke text-sm font-medium" data-id="element-278">
              Offer expires in:
            </span>
            <motion.span animate={isUrgent ? {
            color: ['#E69D4F', '#FFD700', '#E69D4F']
          } : {}} transition={{
            duration: 1,
            repeat: Infinity
          }} className="font-mono text-[#E69D4F] text-xl font-bold tracking-widest" data-id="element-279">
              {formatted}
            </motion.span>
          </div>

          <div className="mb-8" data-id="element-280">
            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full bg-gradient-to-r from-[#F2B851] to-[#C45F2A] border-b-4 border-[#964215] rounded-md text-[#0F1111] font-black uppercase text-base sm:text-xl md:text-2xl py-4 sm:py-6 px-4 sm:px-8 shadow-[0_0_25px_rgba(242,184,81,0.4)] hover:brightness-110 hover:-translate-y-0.5 active:translate-y-0.5 active:border-b-2 transition-all duration-200" data-id="element-281">
              🔥 GET INSTANT ACCESS — $6.99 →
            </button>
          </div>

          <div className="flex flex-col items-center gap-4 text-smoke text-sm" data-id="element-282">
            <div className="flex gap-3" data-id="element-283">
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-284">
                VISA
              </div>
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-285">
                MC
              </div>
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-286">
                AMEX
              </div>
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-287">
                PP
              </div>
            </div>
            <div className="flex items-center gap-2 text-base mt-2" data-id="element-288">
              <LockIcon size={16} data-id="element-289" />
              <span data-id="element-290">Secure 256-bit Encrypted Checkout</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}